import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const namecheap = defineConnector({
  identifier: "namecheap",
  name: "Namecheap",
  tagLine: "Domain registration and management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.namecheap\\.com/.*",
  auth: (app) =>
    queryAuth([
      { name: "ApiKey", value: app.secret.apiKey },
      { name: "ApiUser", value: app.config.apiUser },
      {
        name: "UserName",
        value: app.config.apiUser,
      },
    ]),
  steps: [
    {
      title: "Enable API access",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Namecheap API Access](https://ap.www.namecheap.com/settings/tools/apiaccess/) to enable API access and whitelist your IP address.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API user",
          required: true,
          target: { kind: "configuration", field: "apiUser" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiUser }) =>
      `https://api.namecheap.com/xml.response?ApiUser=${apiUser}&UserName=${apiUser}&Command=namecheap.domains.getList&ClientIp=0.0.0.0`,
  },
});
